export default __webpack_public_path__ + "static/happy-young-girl-laughing-with-friends-b2a5f88db82eae9a0470da9cedbd2634.jpg";